import { render, staticRenderFns } from "./originInfo.vue?vue&type=template&id=4778baa1&scoped=true"
import script from "./originInfo.vue?vue&type=script&lang=js"
export * from "./originInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778baa1",
  null
  
)

export default component.exports